import { createSlice } from "@reduxjs/toolkit";
import { allApi } from "../../../utils/config";
import customaxios from "../../services/axios";
import { exportComplianceInitialState } from "../../../utils/const";

export const callExportComplianceAPI = (payload, submit) => async (dispatch, getState) => {
  try {
    dispatch(
      setLoadingState({
        isLoading: true,
      })
    );
    const res = await customaxios({
      method: "POST",
      url: allApi.exportComplianceResults,
      data: payload,
    });
    const currentData = res?.data?.data;
    const count = res?.data?.total_hits;
    const prevData = getState()?.exportCompliance?.exportComplianceState?.searchResult;
    const totalEmbargoes = res?.data?.total_embargoes;
    const totalCompliances = res?.data?.total_compliances;

    dispatch(
      setExportComplianceQuery({
        searchQuery: payload,
        searchResult: submit ? [...currentData] : [...prevData, ...currentData],
        totalCount: count,
        totalCompliances: totalCompliances,
        totalEmbargoes: totalEmbargoes,
      })
    );

    dispatch(
      setLoadingState({
        isLoading: false,
      })
    );
  } catch (error) {
    console.log("Error", error);
  }
};

const slice = createSlice({
  name: "exportCompliance",
  initialState: exportComplianceInitialState,
  reducers: {
    setExportComplianceQuery: (state, action) => {
      state.exportComplianceState.searchQuery = action.payload.searchQuery;
      state.exportComplianceState.searchResult = action.payload.searchResult;
      state.exportComplianceState.totalCount = action.payload.totalCount;
      state.exportComplianceState.totalCompliances = action.payload.totalCompliances;
      state.exportComplianceState.totalEmbargoes = action.payload.totalEmbargoes;
    },
    setExportComplianceResults: (state, action) => {
      state.exportComplianceState.searchResult = action.payload.searchResult;
    },
    setExportEmbargoesResults: (state, action) => {
      state.exportComplianceState.embargoesResult = [...action.payload.embargoesResult];
    },
    appendExportEmbargoesResults: (state, action) => {
      state.exportComplianceState.embargoesResult = [...state.exportComplianceState.embargoesResult, ...action.payload.embargoesResult];
    },
    appendExportComplianceResults: (state, action) => {
      state.exportComplianceState.searchResult = [...state.exportComplianceState.searchResult, ...action.payload.searchResult];
    },
    setLoadingState: (state, action) => {
      state.isLoading = action.payload.isLoading;
    },
    setFormState: (state, action) => {
      state.formState = action.payload;
    },
    setPaginationState: (state, action) => {
      state.paginationState = action.payload;
    },
    resetExportCompliance: (state, action) => {
      state.exportComplianceState.searchQuery = action?.payload?.exportComplianceState?.searchQuery;
      state.exportComplianceState.searchResult = action?.payload?.exportComplianceState?.searchResult;
      state.exportComplianceState.totalCount = action?.payload?.exportComplianceState?.totalCount;
      state.isLoading = action?.payload?.isLoading;
      state.formState = action?.payload?.formState;
      state.paginationState = action?.payload?.paginationState;
      state.submitButton = action?.payload?.submitButton;
    },
    setCountryOfOrigin: (state, action) => {
      state.countryOfOrigin = action.payload;
    },
    setCountryOfExport: (state, action) => {
      state.setCountryOfExport = action.payload;
    },
    setCountryOfImport: (state, action) => {
      state.countryOfImport = action.payload;
    },
    setDateRangeHandler: (state, action) => {
      state.DateRange = action.payload;
    },
    setSubmitButton: (state, action) => {
      state.submitButton = action.payload;
    },
  },
});

export const {
  setSubmitButton,
  setExportEmbargoesResults,
  appendExportEmbargoesResults,
  setExportComplianceResults,
  appendExportComplianceResults,
  setExportComplianceQuery,
  setLoadingState,
  setFormState,
  setPaginationState,
  resetExportCompliance,
  setCountryOfOrigin,
  setCountryOfExport,
  setCountryOfImport,
  setDateRangeHandler,
} = slice.actions;
export default slice.reducer;
